import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import intl from "react-intl-universal";

import NotFound from './NotFound';
import WaitingComponent from './WaitingComponent';
import NavbarLogo from './navbar/NavbarLogo';

import { isInRange, isNotEmptyString } from '../helpers/JsHelper';

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */

class ThankYouPage extends React.Component {

    constructor(props) {
        super(props);

        const { state = {} } = this.props.location;
        const { referrer = '/', message = '', reason = '', delay = 3000 } = state;

        this.state = {
            redirect: false,
            notFound: !state,
            to: referrer,
            delay: delay,
            message: message,
            reason: reason
        }
    }

    componentDidMount() {
        const { delay } = this.state;
        setTimeout(() => {
            this.setState({
                redirect: true
            })
        }, isInRange(delay, 1000, 10000) ? delay : 3000);
    }

    render() {
        const { event } = this.props.match.params;
        const { notFound, to, message, reason, redirect } = this.state;

        if (notFound) {
            return <NotFound />;
        }

        if (redirect) {
            return <Redirect to={to} />
        }

        console.log(`Event: ${event}. Delayed redirect to: '${to}'`);

        return (
            <div>
                <header id="header" className="header header-bg-transparent header-abs-top">
                    <div className="header-section">
                        <div id="logoAndNav" className="container">
                            <nav className="navbar navbar-expand-md px-3 py-2">
                                <NavbarLogo />
                            </nav>
                        </div>
                    </div>
                </header>

                <main id="content" role="main">
                    <div className="container space-3 text-center">
                        <h1 className="mb-5">{isNotEmptyString(reason) ? reason : intl.get('generic_thank_you')}</h1>
                        {isNotEmptyString(message) && (<p className="mb-5 text-dark">{message}</p>)}
                        <WaitingComponent />
                        <div>
                            You should be redirect to your dashboard in few seconds. If you're in a hurry, click <Link to={to}>here</Link>!
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

export default ThankYouPage;